if (!customElements.get('wine-taste-profile')) {
  class WineTasteProfile extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) return;

      this.content = this.querySelector('[data-wine-profile-content]');
      this.axes = this.querySelector('[data-wine-profile-axes]');
      this.toggleButton = this.querySelector('[data-wine-profile-toggle]');
      this.toggleLabel = this.querySelector('[data-wine-profile-toggle-label]');
      if (!this.content || !this.axes || !this.toggleButton) return;

      this.isInitialized = true;
      this.mobileMedia = matchMedia('(max-width: 989px)');
      this.mobileExpanded = false;
      this.measureFrame = null;
      this.handleToggle = () => {
        this.mobileExpanded = !this.mobileExpanded;
        this.applyState(this.mobileExpanded);
      };
      this.handleMediaChange = () => this.scheduleMeasurement();

      this.toggleButton.addEventListener('click', this.handleToggle);
      if (this.mobileMedia.addEventListener) {
        this.mobileMedia.addEventListener('change', this.handleMediaChange);
      } else {
        this.mobileMedia.addListener(this.handleMediaChange);
      }

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.scheduleMeasurement());
        this.resizeObserver.observe(this.axes);
      }

      document.fonts?.ready.then(() => {
        if (this.isConnected && this.isInitialized) this.scheduleMeasurement();
      });
      this.measure();
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      this.toggleButton.removeEventListener('click', this.handleToggle);
      if (this.mobileMedia.removeEventListener) {
        this.mobileMedia.removeEventListener('change', this.handleMediaChange);
      } else {
        this.mobileMedia.removeListener(this.handleMediaChange);
      }
      this.resizeObserver?.disconnect();
      if (this.measureFrame !== null) cancelAnimationFrame(this.measureFrame);
      this.isInitialized = false;
    }

    scheduleMeasurement() {
      if (!this.isConnected || !this.isInitialized) return;
      if (this.measureFrame !== null) cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => {
        this.measureFrame = null;
        this.measure();
      });
    }

    measure() {
      const fullHeight = Math.ceil(this.content.scrollHeight);
      this.style.setProperty('--wine-profile-expanded-height', `${fullHeight}px`);

      if (!this.mobileMedia.matches) {
        this.dataset.collapsible = 'false';
        this.applyState(true);
        return;
      }

      const rootFontSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      const previewHeight = 13 * rootFontSize;
      const hasEnoughAxes = this.axes.children.length > 2;
      const shouldCollapse = hasEnoughAxes && fullHeight > previewHeight + 1;

      this.dataset.collapsible = shouldCollapse ? 'true' : 'false';
      this.applyState(shouldCollapse ? this.mobileExpanded : true);
    }

    applyState(expanded) {
      const isCollapsible = this.dataset.collapsible === 'true';
      const isExpanded = !isCollapsible || expanded;

      this.dataset.expanded = isExpanded ? 'true' : 'false';
      this.toggleButton.hidden = !isCollapsible;
      this.toggleButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      if (this.toggleLabel) {
        this.toggleLabel.textContent = isExpanded
          ? 'Fold smagsprofilen sammen'
          : 'Vis hele smagsprofilen';
      }

      const hideAxesFromAssistiveTechnology = isCollapsible && !isExpanded;
      this.content.toggleAttribute('inert', hideAxesFromAssistiveTechnology);
      if (hideAxesFromAssistiveTechnology) {
        this.content.setAttribute('aria-hidden', 'true');
      } else {
        this.content.removeAttribute('aria-hidden');
      }
    }
  }

  customElements.define('wine-taste-profile', WineTasteProfile);
}
